// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export function streamToBuffer(): void {
  /* empty */
}

export function streamToBuffer2(): void {
  /* empty */
}

export function readStreamToLocalFile(): void {
  /* empty */
}

export const fsStat = function stat(): void {
  /* empty */
};

export const fsCreateReadStream = function createReadStream(): void {
  /* empty */
};
